module.exports = __webpack_public_path__ + "img/zhaocha_down_code.e62694f0.png";